import { useRouter } from "next/router";
import { useEffect } from "react";
import { getSecurityUuid, setSecurityUuid } from "util/localStorageUtils";
import yieldToMain from "util/lodash/yieldToMain";

function SignifydSecurityTimestamp({ uuid }: { uuid: string }) {
  const { asPath } = useRouter();

  useEffect(() => {
    yieldToMain().then(() => {
      if (uuid) {
        const securityUuid = getSecurityUuid();
        setSecurityUuid(JSON.stringify({
          uuid: securityUuid.uuid || uuid,
          timestamp: new Date().getTime(),
        }));
      }
    });
  }, [asPath]);

  return null;
}

export default SignifydSecurityTimestamp;
